/**
 * 获取代采组
 */
export const getPurchaseGroupList = (params) => {
  return window._this.$http.post("/erp/Common/selectPg", params);
};
/**
 * 获取代采组员
 */
export const getPurchaseMemberList = (params) => {
  return window._this.$http.post("/erp/Common/getPgMember", params);
};
/**
 * 搜索获取档口选项列表
 */
export const fetchSupplyBySearch = (params) => {
  return window._this.$http.post("/erp/Common/fetchSupplyBySearch", params);
};



// WEBPACK FOOTER //
// ./src/api/common.js